import { MsalInstance as msal } from "./msalHelper";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import signOut from "./signOut";

async function TokenManager(scope) {
    let accessToken = '';
    if (!scope) {
        return accessToken;
    }

    let msalInstance = msal.getCurrentInstance()
    const account = msalInstance.getAllAccounts()[0];

    const accessTokenRequest = {
        scopes: [scope],
        account: account,
        forceRefresh: true,
        refreshTokenExpirationOffsetSeconds: 3600
    }

    try {
        const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest);
        accessToken = accessTokenResponse.accessToken;
    }
    catch (error) {
        console.error(error);
        if (error instanceof InteractionRequiredAuthError) {
            signOut(account);
        }
    }

    return accessToken;
}

export default TokenManager;
